import { ht } from "../../../../date-fns/locale/ht.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ht
  }
};